import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50" }

import { useRouter } from 'vue-router';
import SimpleHeader from '@/components/tailwind/header/SimpleHeader.vue';
import SimpleFooter from '@/components/tailwind/footer/SimpleFooter.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PricingLayout',
  setup(__props) {

const router = useRouter();
const close = () => router.push({ name: 'BillingPage' });

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SimpleHeader, {
      "on-close": close,
      pages: []
    }),
    _createVNode(_component_RouterView),
    _createVNode(SimpleFooter, { horizontal: true })
  ]))
}
}

})